// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as publicLayoutRouteImport } from './routes/(public)/layout'
import { Route as authLayoutRouteImport } from './routes/(auth)/layout'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as publicUsesRouteImport } from './routes/(public)/uses'
import { Route as publicStatsRouteImport } from './routes/(public)/stats'
import { Route as publicProfileRouteImport } from './routes/(public)/profile'
import { Route as publicGuestbookRouteImport } from './routes/(public)/guestbook'
import { Route as publicChangelogRouteImport } from './routes/(public)/changelog'
import { Route as publicAboutRouteImport } from './routes/(public)/about'
import { Route as authSigninRouteImport } from './routes/(auth)/signin'
import { Route as publicSnippetsIndexRouteImport } from './routes/(public)/snippets/index'
import { Route as publicProjectsIndexRouteImport } from './routes/(public)/projects/index'
import { Route as publicBookmarksIndexRouteImport } from './routes/(public)/bookmarks/index'
import { Route as publicBlogIndexRouteImport } from './routes/(public)/blog/index'
import { Route as publicSnippetsSnippetIdRouteImport } from './routes/(public)/snippets/$snippetId'
import { Route as publicServicesServiceIdRouteImport } from './routes/(public)/services/$serviceId'
import { Route as publicProjectsProjectIdRouteImport } from './routes/(public)/projects/$projectId'
import { Route as publicBookmarksBookmarkIdRouteImport } from './routes/(public)/bookmarks/$bookmarkId'
import { Route as publicBlogArticleIdRouteImport } from './routes/(public)/blog/$articleId'

const publicLayoutRoute = publicLayoutRouteImport.update({
            id: '/(public)',getParentRoute: () => rootRouteImport
          })
const authLayoutRoute = authLayoutRouteImport.update({
            id: '/(auth)',getParentRoute: () => rootRouteImport
          })
const publicIndexRoute = publicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => publicLayoutRoute
          })
const publicUsesRoute = publicUsesRouteImport.update({
            id: '/uses',path: '/uses',getParentRoute: () => publicLayoutRoute
          })
const publicStatsRoute = publicStatsRouteImport.update({
            id: '/stats',path: '/stats',getParentRoute: () => publicLayoutRoute
          })
const publicProfileRoute = publicProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => publicLayoutRoute
          })
const publicGuestbookRoute = publicGuestbookRouteImport.update({
            id: '/guestbook',path: '/guestbook',getParentRoute: () => publicLayoutRoute
          })
const publicChangelogRoute = publicChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => publicLayoutRoute
          })
const publicAboutRoute = publicAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => publicLayoutRoute
          })
const authSigninRoute = authSigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => authLayoutRoute
          })
const publicSnippetsIndexRoute = publicSnippetsIndexRouteImport.update({
            id: '/snippets/',path: '/snippets/',getParentRoute: () => publicLayoutRoute
          })
const publicProjectsIndexRoute = publicProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => publicLayoutRoute
          })
const publicBookmarksIndexRoute = publicBookmarksIndexRouteImport.update({
            id: '/bookmarks/',path: '/bookmarks/',getParentRoute: () => publicLayoutRoute
          })
const publicBlogIndexRoute = publicBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => publicLayoutRoute
          })
const publicSnippetsSnippetIdRoute = publicSnippetsSnippetIdRouteImport.update({
            id: '/snippets/$snippetId',path: '/snippets/$snippetId',getParentRoute: () => publicLayoutRoute
          })
const publicServicesServiceIdRoute = publicServicesServiceIdRouteImport.update({
            id: '/services/$serviceId',path: '/services/$serviceId',getParentRoute: () => publicLayoutRoute
          })
const publicProjectsProjectIdRoute = publicProjectsProjectIdRouteImport.update({
            id: '/projects/$projectId',path: '/projects/$projectId',getParentRoute: () => publicLayoutRoute
          })
const publicBookmarksBookmarkIdRoute = publicBookmarksBookmarkIdRouteImport.update({
            id: '/bookmarks/$bookmarkId',path: '/bookmarks/$bookmarkId',getParentRoute: () => publicLayoutRoute
          })
const publicBlogArticleIdRoute = publicBlogArticleIdRouteImport.update({
            id: '/blog/$articleId',path: '/blog/$articleId',getParentRoute: () => publicLayoutRoute
          })





const authLayoutRouteChildren = {
  authSigninRoute: authSigninRoute
}

const authLayoutRouteWithChildren = authLayoutRoute._addFileChildren(authLayoutRouteChildren)




const publicLayoutRouteChildren = {
  publicAboutRoute: publicAboutRoute,publicChangelogRoute: publicChangelogRoute,publicGuestbookRoute: publicGuestbookRoute,publicProfileRoute: publicProfileRoute,publicStatsRoute: publicStatsRoute,publicUsesRoute: publicUsesRoute,publicIndexRoute: publicIndexRoute,publicBlogArticleIdRoute: publicBlogArticleIdRoute,publicBookmarksBookmarkIdRoute: publicBookmarksBookmarkIdRoute,publicProjectsProjectIdRoute: publicProjectsProjectIdRoute,publicServicesServiceIdRoute: publicServicesServiceIdRoute,publicSnippetsSnippetIdRoute: publicSnippetsSnippetIdRoute,publicBlogIndexRoute: publicBlogIndexRoute,publicBookmarksIndexRoute: publicBookmarksIndexRoute,publicProjectsIndexRoute: publicProjectsIndexRoute,publicSnippetsIndexRoute: publicSnippetsIndexRoute
}

const publicLayoutRouteWithChildren = publicLayoutRoute._addFileChildren(publicLayoutRouteChildren)

const rootRouteChildren = {
  authLayoutRoute: authLayoutRouteWithChildren,publicLayoutRoute: publicLayoutRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)